<div class="container-fluid" [ngClass]="!theme ? 'dark-theme' : ''">
    <div class="row">
        <div class="col-sm-12 p-0">
            <div class="card mb-0 border-0">
                <div class="card-body p-0">
                    <div class="profile-bg  position-relative">
                        <div class="bg-overlay p-48">
                            <h1 class="fw-bold txt-blue">Hey, {{userData?.first_name}}<span class="wave">👋</span>
                                <h1 class="txt-blue txt-heading mt-2 mb-2">Welcome to Strell </h1>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-4">

        <div class="col-sm-4 card1 flex-1" (click)="navigateToaudit()">
            <div class="d-flex align-items-center card-content">
                <div class="w-25">
                    <img src="assets/images/audit-dashboard-new.svg" alt="" class="logo" height="80" width="99" [ngClass]="!theme ? 'bright-image' : ''">
                </div>
                <div class="w-75">
                    <h2 class="Neutral mb-1">Audit</h2>
                    <p class="small txt-gray">Optimize Your Existing Page With Top 20 Competitors Data</p>
                </div>
            </div>

            <div class="go-corner d-flex justify-content-center align-items-center position-absolute">
                <div class="go-arrow txt-gray">
                    →
                </div>
            </div>
        </div>
        <div class="col-sm-4 card1 flex-1" (click)="navigateToContentEditor()">
            <div class="d-flex align-items-center card-content">
                <div class="w-25">
                    <img src="assets/images/content-writing-dashboard-new.svg" alt="" class="logo" height="80" width="99" [ngClass]="!theme ? 'bright-image' : ''">
                </div>
                <div class="w-75">
                    <h2 class="Neutral mb-1">Content Editor</h2>
                    <p class="small txt-gray">Create Optimized Content With Our AI Insights</p>
                </div>
            </div>

            <div class="go-corner d-flex justify-content-center align-items-center position-absolute">
                <div class="go-arrow txt-gray">
                    →
                </div>
            </div>
        </div>
        <div class="col-sm-4 card1 flex-1" (click)="navigateTolckr()">
            <div class="d-flex align-items-center card-content">
                <div class="w-25">
                    <img src="assets/images/lckr-dashboard-new.svg"  alt="" class="logo" height="80" width="99" [ngClass]="!theme ? 'bright-image' : ''">
                </div>
                <div class="w-75">
                    <h2 class="Neutral mb-1">LCKR</h2>
                    <p class="small txt-gray">Find easy-to-rank keywords easily</p>
                </div>
            </div>

            <div class="go-corner d-flex justify-content-center align-items-center position-absolute">
                <div class="go-arrow txt-gray">
                    →
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 cardd1 mb-2">

        <div class="fw-bold d-flex justify-content-center align-items-center">
            <!-- <h1 class="fw-bold me-5">1</h1> -->
            <h1 class="Neutral p-0 m-0">Ready to Dive in?</h1>
        </div>
        <div class="mt-2 d-flex justify-content-center align-items-center">
            <!-- <h1 class="fw-bold me-5">2</h1> -->
            <p class="txt-gray">Get started in 2 Minutes flat! it's easier than teaching
                your dog new tricks</p>
        </div>
        <div class="mt-2 fw-bold d-flex justify-content-center align-items-center">
            <div class="d-flex flex-column align-items-center me-2">
                <button class="btn" (click)="getEmbedCodeLckr('lckr')" [ngClass]="embedCode==='lckr' && !!isLckr ? 'embed-btn-primary' : 'embed-btn'">LCKR</button>
                <!-- <h1 class="fw-bold">3</h1> -->
            </div>
            <div class="d-flex flex-column align-items-center me-2">
                <button class="btn" (click)="getEmbedCodeContentEditor('contentEditor')" [ngClass]="embedCode==='contentEditor' && isCe ? 'embed-btn-primary' : 'embed-btn'">Content Editor</button>
                <!-- <h1 class="fw-bold">4</h1> -->
            </div>
        </div>
        <div *ngIf="embedCode==='lckr' && !!isLckr" class="d-flex justify-content-center"
            style="padding-bottom: calc(62.5% + 41px); height: 0; width: 100%; z-index: 9">
            <iframe src="https://embed.getsmartcue.com/II09GIX8" frameborder="0" loading="lazy" webkitallowfullscreen
                mozallowfullscreen allowfullscreen
                style="position: absolute; top: 50; left: 50; width: 80%; height: 80%;" title="LCKR Showcase"></iframe>
        </div>
        <div *ngIf="embedCode==='contentEditor'&& !!isCe" class="d-flex justify-content-center" style="padding-bottom: calc(62.5% + 41px); height: 0; width: 100%; z-index: 9">
            <iframe src="https://embed.getsmartcue.com/IWCSHBVP" frameborder="0" loading="lazy" webkitallowfullscreen
                mozallowfullscreen allowfullscreen
                style="position: absolute; top: 50; left: 50; width: 80%; height: 80%;" title="Content Editor"></iframe>
        </div>
    </div>
</div>